import React from 'react';

import '../stylings/LoadingSpinner.css';


export class LoadingSpinner extends React.Component {
	render() {
		return (
			<div className="loading-spinner">
				<div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/LoadingSpinner.component.js